// src/utils/axiosConfig.ts
import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosError, AxiosRequestHeaders } from 'axios';
import {CommonLibrary} from '../contexts/CommonContext';

// This is an Axios factory, not a React hook. Keep the legacy export for other pages.
const createAdminAxios = (projectIdOverride?: number): AxiosInstance => {
    const axiosInstance = axios.create();
    const commonLibrary = new CommonLibrary();
    axiosInstance.interceptors.request.use(
        (config: InternalAxiosRequestConfig) => {
            const token = localStorage.getItem('sso-auth');
            const projectId = projectIdOverride ?? commonLibrary.ProjectId;
            // Read the current language from local storage of set a default if it doesn't exist
            const i18Lang= localStorage.getItem('i18nextLng');
            const localization = i18Lang ? i18Lang : 'en-EU';
            if (token) {
                config.headers = {
                    ...config.headers,
                    'tokennetcore': token,
                    'localization': localization,
                    'projectId': projectId,
                    'Access-Control-Allow-Origin' : '*'
                } as unknown as AxiosRequestHeaders;
            }
            else{
                config.headers = {
                    ...config.headers,                    
                    'Access-Control-Allow-Origin' : '*'
                } as unknown as AxiosRequestHeaders;
            }

            if (!(config.data instanceof FormData)) {
                config.headers['Content-Type'] = 'application/json';
            }

            return config;
        },
        (error: AxiosError) => {
            return Promise.reject(error);
        }
    );

    return axiosInstance;
};

const useAxios = createAdminAxios;
export { useAxios, createAdminAxios };
